export const errorTypes: Record<string, Error> = {
    inputDataError: {
        name: 'Checkout Error',
        message: 'Invalid input data',
    },
};
